import { Component } from '@angular/core';

/**
 * Blank placeholder component used exclusively by the provider route
 * (/main/provider/:providerId). It renders nothing — the ProviderGuard
 * always redirects before this component becomes visible.
 */
@Component({
  standalone: true,
  template: '',
  host: { 'data-component': 'provider-redirect' }
})
export class ProviderRedirectComponent {}
